export default __webpack_public_path__ + "static/media/terms-dog.41675ec1.png";